
import { Button } from "@progress/kendo-react-buttons";
import { useTranslation } from "react-i18next";

interface GxSecondarySmallButtonProps {
  handleSubmit?: (e: React.FormEvent) => void;
  label?: string;
  type?: "button" | "submit";
  buttonloading?: boolean;
  submitDisabled?: boolean; 
}
const GxSecondarySmallButton: React.FC<GxSecondarySmallButtonProps> = ({
  handleSubmit,
  label="",
  type,
  submitDisabled,
}) => {
  const { t } = useTranslation();
  return (
    <Button
      type={type}
      onClick={handleSubmit}
      disabled={submitDisabled}
      className="gx-dialog-action-button-small-white gx-submit-for-approval-small "
    >
      <span className="gx-h4-small"> {t(label)}</span>
    </Button>
  );
};

export default GxSecondarySmallButton;
